__turbopack_context__.v({
  "appleButton": "styles-module__KD3-Wq__appleButton",
  "appleIconWrapper": "styles-module__KD3-Wq__appleIconWrapper",
  "buttonText": "styles-module__KD3-Wq__buttonText",
  "wrapper": "styles-module__KD3-Wq__wrapper",
});
